module.exports = __webpack_public_path__ + "img/weekly-bonus.bce1cf07.png";